<script setup lang="ts">
import { showErrorMsg, watch } from '#imports';
import { declareProviders, useService } from '@kaokei/use-vue-service';
import GatherInfoModal from '~/components/GatherInfoModal/GatherInfoModal.vue';
import { FreshTasksService } from './FreshTasks.service';

const service = useService(FreshTasksService);

const checkIfFormItemBlank = (itemValue: string) => {
  const value = service.preGatherInfo.data[itemValue];
  if (value === null || value === undefined) return true;
  if (typeof value === 'string' && !value.trim()) return true;
  if (typeof value === 'number' && value === 0) return true;
  return false;
};
watch(
  () => service.gatherInfoVisible,
  (visible) => {
    if (visible) {
      service.checkPreGatherInfo();
    }
  },
  {
    immediate: true,
  },
);
const handleFinish = () => {
  service
    .completeUserInfo()
    .then(() => {
      service.init();
    })
    .catch((err) => {
      showErrorMsg('提交失败', err);
    });
};
</script>

<template>
  <GatherInfoModal
    v-model:open="service.gatherInfoVisible"
    v-model:value="service.gatherInfo.formData"
    title="完善个人信息"
    ok-text="完成"
    :preloading="service.preGatherInfo.loading"
    :loading="service.gatherInfo.loading"
    :form-btn-disabled="service.formBtnDisabled"
    :check-is-form-item-visible="checkIfFormItemBlank"
    :handle-on-validate="service.handleOnValidate"
    @finish="handleFinish"
  />
</template>
